<template>
  <section class="maptitlelayer">
    <section
      v-for="(item, index) in status.mapList"
      :key="index"
      class="content-layout"
      :class="index === status.mapList.length - 1 ? 'mr-0px' : 'mr-5px'"
      @click="handleSelectType(item)"
    >
      <section v-if="item.checked" class="icon-content">
        <el-icon size="16" color="#409eff"><CircleCheckFilled /></el-icon>
      </section>
      <!--  @ts-ignore: TS7026 -->
      <img class="titleImg" :src="item.iconUrl" />
      <span class="text">{{ item.label }}</span>
    </section>
  </section>
</template>

<script setup lang="ts">
import { reactive } from 'vue'
import { useUtilsHooks } from '@map-sdk/hooks'
import { baseMapTitleLayerConfig } from './config'
import type { BaseMapTileLayerType } from './config'
import type { MyMap } from '@map-sdk/sdk'

interface MapProps {
  map: MyMap
}
// isMobile,
const { getMapTitleLayer, switchBaseMap } = useUtilsHooks()
const mapProps = defineProps<MapProps>()
defineOptions({
  name: 'BaseMapTitleLayer',
})
const status = reactive({
  mapList: getMapTitleLayer(mapProps.map, baseMapTitleLayerConfig),
})

switchBaseMap(mapProps.map, status.mapList[0])
/**
 * 地图选择
 * @param {*} item
 */
const handleSelectType = (item: BaseMapTileLayerType) => {
  status.mapList = status.mapList.map((itemC) => ({
    ...itemC,
    checked: itemC.label === item.label,
  }))
  switchBaseMap(mapProps.map, item)
}
</script>
